// Global Instructions Rule Applied! - April 9, 2026
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { resolveDealsReportId } from '../utils/reportingGridColumns.ts'

/**
 * `reporting_config.id` for the Deals table column layout (from global configs).
 */
export function useDealsReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () => resolveDealsReportId(reportingConfigs, menuItems),
    [menuItems, reportingConfigs]
  )
}
